import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, List, ListItem, ListItemText, Paper } from '@mui/material';

const DataQa = () => {
  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Data QA
      </Typography>
      <Paper>
        <List>
          <ListItem button component={Link} to="/console/data-qa/company-model">
            <ListItemText primary="Company Model" />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
};

export default DataQa;
